import cx from "classnames";
import styles from "./OverlapArea.module.css";

export const OverlapArea = ({ children, noOverlap }) => (
  <div className={styles.container}>
    <div className={cx(styles.overlap, { [styles.noOverlap]: noOverlap })} />
    {children}
  </div>
);
